/**
 * Decide whether to show the "preparing the game" beat on the game screen.
 *
 * Two ways a member arrives at a just-started game:
 *   1. They watched the LOBBY → ACTIVE flip on THIS screen (a join filled the
 *      last seat, or the host tapped Start while viewing the lobby).
 *   2. They mount straight into an ACTIVE game that auto-started ELSEWHERE — most
 *      notably the host adding the final bot on the Add Players screen, which
 *      then redirects to the game screen already-ACTIVE, so the screen never saw
 *      a LOBBY previous status. We detect that via a freshly-set `startedAt`.
 *
 * Pure so it's unit-testable; the caller latches with a ref to fire once.
 */

/** A game whose `startedAt` is within this window counts as "just started". */
export const JUST_STARTED_MS = 4000

export function shouldBeginStartPrep(opts: {
  prevStatus: string | undefined
  status: string | undefined
  startedAt: string | null | undefined
  isMember: boolean
  now: number
}): boolean {
  const { prevStatus, status, startedAt, isMember, now } = opts
  if (!isMember || status !== 'ACTIVE') return false
  // (1) Observed the transition on this screen.
  if (prevStatus === 'LOBBY') return true
  // (2) Arrived fresh at a game that just started elsewhere.
  if (startedAt) {
    const t = Date.parse(startedAt)
    if (!Number.isNaN(t) && now - t < JUST_STARTED_MS) return true
  }
  return false
}
